export enum CookieConsentType {
  STATISTICS = 'statistics',
  PREFERENCES = 'preferences',
}
